import { Subscription, TeacherProfile } from 'types/collections';

import { DailyAvailability } from '@components/DaySelectionPanel';

/**
 * Initialize selected days based on subscription data, teacher profile, or default to false
 * @param subscription Optional subscription data to use for initialization
 * @param teacherProfile Optional teacher profile data to use as fallback
 * @returns DailyAvailability object with monday through friday boolean values
 */
export function initializeSelectedDays(
  subscription?: Subscription,
  teacherProfile?: TeacherProfile,
): DailyAvailability {
  if (subscription) {
    return {
      monday: subscription.monday ?? false,
      tuesday: subscription.tuesday ?? false,
      wednesday: subscription.wednesday ?? false,
      thursday: subscription.thursday ?? false,
      friday: subscription.friday ?? false,
    };
  } else if (teacherProfile) {
    return {
      monday: teacherProfile.general_availability_monday ?? false,
      tuesday: teacherProfile.general_availability_tuesday ?? false,
      wednesday: teacherProfile.general_availability_wednesday ?? false,
      thursday: teacherProfile.general_availability_thursday ?? false,
      friday: teacherProfile.general_availability_friday ?? false,
    };
  }
  return {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
  };
}

/**
 * Helper function to toggle availability days
 */
export function toggleDayInAvailability(
  prev: DailyAvailability,
  day: keyof DailyAvailability,
): DailyAvailability {
  return {
    ...prev,
    [day]: !prev[day],
  };
}

/**
 * Helper function to build the payload for the updateTeacherProfile function
 * for the general availability days
 */
export function buildAvailabilityPayload(days: DailyAvailability): { [key: string]: boolean } {
  return Object.entries(days).reduce(
    (acc, [day, value]) => {
      acc[`general_availability_${day}`] = value || false;
      return acc;
    },
    {} as { [key: string]: boolean },
  );
}
